import { isDefined } from "@clipboard-health/util-ts";
import { isBefore } from "date-fns";

export interface AfterClockOutOrBreakErrorResult {
  isValid: boolean;
  errorType: "AFTER_CLOCK_OUT_OR_BREAK";
  message: string;
}

export function checkAfterClockOutOrBreakError(
  selectedTime: Date,
  clockOutTime?: Date,
  breakStartTime?: Date
): AfterClockOutOrBreakErrorResult | undefined {
  // For clock out, we still treat equality as invalid (clock in cannot be at or after clock out).
  if (isDefined(clockOutTime) && !isBefore(selectedTime, clockOutTime)) {
    return {
      isValid: false,
      errorType: "AFTER_CLOCK_OUT_OR_BREAK",
      message: "Clock in time cannot be set after clock out time.",
    };
  }

  // For break start, we allow equality (edge case where break starts exactly at clock in),
  // and only block when clock in is strictly after the break start time.
  if (isDefined(breakStartTime) && isBefore(breakStartTime, selectedTime)) {
    return {
      isValid: false,
      errorType: "AFTER_CLOCK_OUT_OR_BREAK",
      message: "Clock in time cannot be set after break start time.",
    };
  }

  return undefined;
}
